import styled from "styled-components";

export const ExportsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 36px;

  tr th {
    color: ${({ theme }) => theme.colors.gray[600]};
    font-size: clamp(12px, 1vw, 16px);
    font-weight: 600;
    flex: 1 !important;
    min-width: 88px;
  }
  tr td {
    white-space: nowrap;
    color: ${({ theme }) => theme.colors.gray[500]};
    font-size: clamp(12px, 1vw, 16px);
    font-weight: 500;
  }
  tr td:first-child {
    text-overflow: ellipsis;
      text-align: center; /* Centraliza o conteúdo das células */
      max-height: 58px;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;

    > div {
      margin: 0 auto;
      display: flex;
      align-items: center;
      gap: 8px;
      width: 124px;
    }

    p {
      margin: 0;
      font: inherit;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
  }

  .infiniteScroll {
    padding: 0 2px 10px 2px;
  }
`;